"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _Icon = _interopRequireDefault(require("./Icon"));

var _deprecationWarning = _interopRequireDefault(require("./utils/deprecationWarning"));

var _default = _deprecationWarning.default.wrapper(_Icon.default, '`<IconFont>`', '`<Icon>`', 'https://rsuitejs.com/components/icon');

exports.default = _default;